import * as React from 'react';

function SvgIntroMade(props) {
  return (
    <svg
      width={22}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 1.833a4.358 4.358 0 00-4.354 4.354c0 2.356 1.842 4.263 4.244 4.346a.737.737 0 01.202 0h.064a4.343 4.343 0 004.198-4.346A4.358 4.358 0 0011 1.833zM15.657 12.98c-2.558-1.705-6.729-1.705-9.305 0-1.164.77-1.805 1.824-1.805 2.952 0 1.127.641 2.172 1.796 2.942 1.284.862 2.97 1.293 4.657 1.293 1.687 0 3.373-.431 4.657-1.293 1.155-.779 1.796-1.824 1.796-2.96-.009-1.119-.641-2.173-1.796-2.934zm-2.521 2.2l-2.31 2.31a.569.569 0 01-.404.165.61.61 0 01-.403-.165l-1.155-1.155a.576.576 0 010-.807c.22-.22.587-.22.807 0l.752.752 1.906-1.907c.22-.22.587-.22.807 0a.56.56 0 010 .807z"
        fill="#4810E9"
      />
    </svg>
  );
}

export default SvgIntroMade;
